import { useCallback } from 'react';
import { getFeed } from 'actions';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { editSubscription, getSubscriptions } from '../actions';
import { selectIncludeIncomeSubscriptions } from '../selectors';
/**
 * Records the reason on each given subscription (a whole duplicate group, so it
 * stays dismissed whichever of them the backend looks at), then refetches so the
 * banner and labels update. With `deactivate`, the same request also stops
 * tracking them. Resolves false when any request failed; the API middleware has
 * already shown the error. It still refetches if any of them saved: the backend
 * stops flagging a company once one of its subscriptions has a dismissal
 * reason, so a partly saved group is already resolved there.
 */
const useDismissDuplicateGroup = () => {
    const dispatch = useAppDispatch();
    const includeIncome = useAppSelector(selectIncludeIncomeSubscriptions);
    const [, , , fetch] = useFetchOld(muteErrorAndResult);
    return useCallback(async (subscriptions, reason, { deactivate = false } = {}) => {
        const responses = await Promise.all(subscriptions.map(({ id }) => fetch(editSubscription(id, {
            duplicateDismissalReason: reason,
            ...(deactivate && { isActive: false }),
        }))));
        if (responses.some(Boolean)) {
            dispatch(getFeed());
            dispatch(getSubscriptions(includeIncome));
        }
        return responses.every(Boolean);
    }, [dispatch, fetch, includeIncome]);
};
export default useDismissDuplicateGroup;
